import { render, staticRenderFns } from "./PostAssessment.vue?vue&type=template&id=76ac8746"
import script from "./PostAssessment.vue?vue&type=script&lang=js"
export * from "./PostAssessment.vue?vue&type=script&lang=js"
import style0 from "./PostAssessment.vue?vue&type=style&index=0&id=76ac8746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports